import { render } from "./RfqsShowList.vue?vue&type=template&id=5b3e9d98"
import script from "./RfqsShowList.vue?vue&type=script&lang=js"
export * from "./RfqsShowList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__